import { Component, ComponentRef, EventEmitter, OnInit, Output } from "@angular/core";
import { GeneralComponent } from "../general.component";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormularioService } from "src/app/services/formulario.service";
import { GeneralService } from "src/app/services/general.service";
import { NotificationService } from "src/app/services/notification.service";
import { MatDialog } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import { DropDownListDTO } from "src/app/entity/dto/dropdownlist.component";
import { take } from "rxjs/operators";
import { Sec002CardIIComponent } from "src/app/views/form-sec002/partialViews/sec002-card-II.component";
import { error } from "console";
@Component({
    selector: 'app-sec002-secagem-item',
    templateUrl: './sec002-secagem-item.component.html',
})
export class Sec002SecagemItemComponent extends GeneralComponent implements OnInit {

    public formulario?: FormGroup;
    public parentRef: Sec002CardIIComponent;
    public unique_key: number;
    public btnExcluir = false
    @Output() componentsReferences = Array<ComponentRef<Sec002SecagemItemComponent>>()
    @Output() mkCalc = new EventEmitter<Number>();
    @Output() calcDates = new EventEmitter();
    public listRessecagem?: DropDownListDTO[];

    constructor(protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        public dialog: MatDialog,
        private add: Store<any>,) {
        super('', false);
        this.formulario = this.formBuilder.group({
            id: [null, []],
            amostragem_data_inicio: ['', [Validators.pattern(this.regexDate)]],
            amostragem_hora_inicio: ['', [Validators.pattern(this.regexHour)]],
            amostragem_data_fim: ['', [Validators.pattern(this.regexDate)]],
            amostragem_hora_fim: ['', [Validators.pattern(this.regexHour)]],
            amostra_1_umidade: [null, [Validators.required]],
            amostra_2_umidade: [null, [Validators.required]],
            amostra_3_umidade: [null, []],
            umidade_media: [null, [Validators.required]],
            andar_secador: [null, [Validators.pattern("^(1|2|3)$"), Validators.required]],
            numero_secador: [null, [Validators.pattern("^(1|2|3)$"), Validators.required]],
            numero_dumper: [null, [Validators.pattern("(0?[1-9]|1[0-8])"), Validators.required]],
            secagem_frio: [null, [Validators.required]],
            finalizou_secagem_caixa: [null, [Validators.required]],
            Ressecagem: [null, [Validators.required]],
            peso_pos_secagem: [null, [Validators.required]]
        });
    }

    async ngOnInit() {
        this.getListOption();
    }
    hasErrorFormControl(campoFormulario: AbstractControl) {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }
    makeCalculations() {
        this.mkCalc.emit();
    }

    calcDatesEvent($event) {
        if (this.formulario?.get('amostragem_data_inicio').value &&
            this.formulario?.get('amostragem_hora_inicio').value &&
            this.formulario?.get('amostragem_data_fim').value &&
            this.formulario?.get('amostragem_hora_fim').value) {
            var dateInit = this.generalService.createDateTimeData(this.formulario?.get('amostragem_data_inicio').value, this.formulario?.get('amostragem_hora_inicio').value);
            var dateEnd = this.generalService.createDateTimeData(this.formulario?.get('amostragem_data_fim').value, this.formulario?.get('amostragem_hora_fim').value);

            if (dateInit > dateEnd) {
                this.formulario?.get('amostragem_data_fim').setErrors({ dateInitHighDateEnd: true });
                this.formulario?.get('amostragem_hora_fim').setErrors({ dateInitHighDateEnd: true });
            }
            else {
                this.formulario?.get('amostragem_data_fim').setErrors(null);
                this.formulario?.get('amostragem_hora_fim').setErrors(null);
                this.calcDates.emit();
            }
        }
    }

    public remove(lastItem = false) {
        // this.loteDsDeletedEmitter.emit();
        this.parentRef.removeSecagemItemComponent(this.unique_key, lastItem);
        // this.componentsReferences.pop();

    }

    calcPesoLiquido() {
        const pesoBruto = this.formulario.get('Peso_bruto')?.value as number
        const pesoTara = this.formulario.get('Peso_tara')?.value as number
        if (pesoBruto == null) {
            return
        }
        const calc = pesoBruto - pesoTara;
        this.formulario.get('Peso_liquido').setValue(Number(calc.toFixed(2)))
        this.makeCalculations();
    }

    setSecagemFrio($event: any) {
        if (this.formulario?.get("numero_secador").value == 3)
            this.formulario?.get("secagem_frio").setValue("Sim");
        else
            this.formulario?.get("secagem_frio").setValue("Não");
    }

    private async getListOption(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'Ressecagem', 'PET').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listRessecagem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    // updatePeso($event) {
    //     this.formulario?.get('rendimento_pos_secagem').setValue((this.formulario?.get('peso_pos_secagem').value * 100) / this.parentRef.pesoTotalRW);
    //     if (this.formulario?.get('rendimento_pos_secagem').value > 100) {
    //         this.formulario?.get('rendimento_pos_secagem').setErrors({ error: true });
    //     }
    // }

}